<ng-template #defaultTabButtons let-c="close" let-d="dismiss">
    <!-- <div class="modal-body text-white backgroundTable">
        <div class=" mx-5 ">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight">Asignar Dependencia.</div>
              
              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
            </div>
          </div>

        <div class="componente-importantes-from">
            <div class="p-3 row mt-3" >
                <form
                    action=""
                    method="post"
                    (submit)="formSubmit()"
                    [formGroup]="dependenceForm">
                <br>
                <div class="col-12">
                    <select required class="custom-outline-input form-control" id="dependenceId" formControlName="dependenceId" >
                    <option selected value="">Seleccione una dependencia</option>
                    <option *ngFor="let item of listProjectStage" [value]="item.id">
                      {{ item.name }} - {{ item.startDate }} / {{ item.endDate }}
                    </option>
                  </select>
                </div>
                <br>
                <div class="col-12 mt-3 d-flex justify-content-center">
                    <button class="btn btn-outline-light ">Guardar</button>
                </div>
                </form>
            </div>
        </div>
        

    </div> -->
    <div class="backgroundTable text-white" ngbAutofocus>
        <div class=" mx-5 ">
          <div class="row my-2">
            <div class="col-9 align-self-center p-2 bd-highlight">Asignar dependecia</div>
            
            <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
          </div>
        </div>
        <div class="componente-importantes-from-popup p-3">
            <!-- <table class="table componente-importantes text-white " style="font-size: 12px;">
    
                <tr>
                    <th colspan="2">
                        <span class="h5">Asignacion/es  
                            <span *ngIf="listAssignment.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                            <span *ngIf="listAssignment.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                            </span>
                    </th>
    
                </tr>
                <br>
        
                <tr *ngFor="let item of listAssignment"  >
                    <td class="text-start">
                       <span style="font-size: 18px;">{{item.username}}</span> 
                    </td>
    
                    <td >
                        <div class="p-2 bd-highlight d-flex flex-column">
                            <span *ngIf="item.stado === 'PENDIENTE'"
                              class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                            <span *ngIf="item.stado === 'EN CURSO'"
                              class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                        </div>
                        
                    </td>
                </tr>
                   
                <tr >
                    <th class="pt-3" colspan="2">
                        <span class="h5">Pago/s 
                            <span *ngIf="listPayment.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                            <span *ngIf="listPayment.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                            </span>
                    </th>
                    <th></th>
    
                </tr>
                <br>
                <tr *ngFor="let item of listPayment">
                    <td class="text-start">
                       <span  style="font-size: 18px;">{{item.title}} </span> 
                    </td>
                    <td>
                        <div class="p-2 bd-highlight d-flex flex-column">
                            <span *ngIf="item.stado === 'PENDIENTE'"
                              class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                            <span *ngIf="item.stado === 'EN CURSO'"
                              class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                        </div>
                    </td>
    
    
                </tr>
    
            </table> -->
            <form
            action=""
            method="post"
            (submit)="formSubmit()"
            [formGroup]="dependenceForm">
        <br>
        <div class="col-12">
            <select required class="custom-outline-input form-control" id="dependenceId" formControlName="dependenceId" >
            <option selected value="">Seleccione una dependencia</option>
            <option *ngFor="let item of listProjectStage" [value]="item.id">
              {{ item.name }} - {{ item.startDate }} / {{ item.endDate }}
            </option>
          </select>
        </div>
        <br>
        <div class="col-12 mt-3 d-flex justify-content-center">
            <button class="btn btn-outline-light ">Guardar</button>
        </div>
        </form>
            </div>

        
        </div>

</ng-template>